import { extractMentions } from "../../Announcements/components/RichTextEditor/extractMentions";

function buildEventPayload(
	data: Partial<MeeEvent>,
	imageReference: string | null,
	imageRemoved: boolean,
	audienceGroupIds: number[]
): Record<string, unknown> {
	const bodyHtml = data.body ?? "";
	const { userIds, hashtagIds } = extractMentions(bodyHtml);
	return {
		name: data.name ?? "",
		location: data.location ?? "",
		body: bodyHtml,
		start_date: data.startDate ?? null,
		show_start_date: data.showStartDate ?? true,
		end_date: data.endDate ?? null,
		show_end_date: data.showEndDate ?? true,
		tag: data.tag ?? "",
		image_reference: imageReference ?? null,
		image_removed: imageRemoved,
		audience_group_ids: audienceGroupIds,
		mention_user_ids: userIds,
		hashtag_ids: hashtagIds
	};
}

export const adaptCreateEventPayload = (
	data: Partial<MeeEvent>,
	imageReference: string | null,
	audienceGroupIds: number[] = []
): Record<string, unknown> => {
	return buildEventPayload(data, imageReference, false, audienceGroupIds);
};

export const adaptEditEventPayload = (
	data: Partial<MeeEvent>,
	imageReference: string | null,
	imageRemoved = false,
	audienceGroupIds: number[] = []
): Record<string, unknown> => {
	return buildEventPayload(
		data,
		imageReference,
		imageRemoved,
		audienceGroupIds
	);
};
